export default "__VITE_ASSET__962aeac4__"